import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combina classes condicionalmente (clsx) e mescla conflitos Tailwind
 * (tailwind-merge). Uso universal em todos os primitivos do design system.
 *
 * @example
 * cn('px-4 py-2', condition && 'bg-primary', className)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
